import { useState } from "react";
import { ddEndAdornmentSx, workDoneDropdownSx } from "../../utils/helper";
import Dropdown from "../common/Dropdown";

function loadTranslate() {
  // console.log('hex')
}

window.loadTranslate = loadTranslate

const LanguageSelector = () => {

  const [lang, setLang] = useState('English')

  // const changeLanguage = (lng) => {
  //   // Set the "lang" attribute on the <html> tagdocument.documentElement.lang = lng;
  //   const meta = document.createElement("meta")

  //   // Trigger Chrome's translation featureconst meta = document.createElement('meta');
  //   meta.name = 'google';
  //   meta.content = 'notranslate';
  //   document.head.appendChild(meta);

  //   if (lng !== 'en') {
  //     document.head.removeChild(meta);
  //   }
  // };
  function changeLanguage(lang) {
    var frame = document.querySelector('iframe.goog-te-banner-frame');
    if (frame) {
      var frameDoc = frame.contentDocument || frame.contentWindow.document;
      var langSelect = frameDoc.querySelector('select.goog-te-combo');
      if (langSelect) {
        langSelect.value = lang;
        langSelect.dispatchEvent(new Event('change'));
      }
    }
  }

  return (
    <>
    {/* <Dropdown
      name={"lang"}
      className={"lambda relative top-[-7px]"}
      value={lang}
      showErrorText={false}
      onChange={(e) => {
        setLang(e.target.value)
  console.log('hex', e.target.value)

        if (e.target.value === "Marathi") {
          // new window.google.translate.TranslateElement({ pageLanguage: 'mr' }, 'google_translate_element');
          changeLanguage("mr")
        } else {
          // new window.google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element');
          changeLanguage("en")
          
        }
      }}
      options={["English", "Marathi"]}
      showLegend={true}
      sx={{
        zIndex : '200000000000',
        position: 'absolute',
        top: 0,
        left: 0,
        ...workDoneDropdownSx,
        ...ddEndAdornmentSx,
        '& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input': {
          paddingBlock: '0px',
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root': {
          backgroundColor: "#fff"
        }
      }}
    /> */}
    {/* <div class="z-[200000000000] absolute top-0 left-0" id="google_translate_element"></div> */}
    <div class="gtranslate_wrapper">
      
    </div>
    </>
    // <select className="z-[200000000] absolute top-0 left-0" onChange={(e) => changeLanguage(e.target.value)}>
    //   <option value="en">English</option><option value="mr">Marathi</option>
    //   {/* Add more languages as needed */}
    // </select>
  );
};

export default LanguageSelector;